import './typedefs'
import http from '@/http'

const PATH = '/sipcentric/customers'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listCustomers (params) {
        try {
            const response = await http.get(PATH, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{id: number}} data
     * @returns {Promise<void>}
     */
    async showCustomer ({id}) {
        try {
            const response = await http.get(`${PATH}/${id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {SipcentricCustomer} data
     * @returns {Promise<void>}
     */
    async createCustomer (data) {
        try {
            const response = await http.post(PATH, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {SipcentricCustomer} data
     * @returns {Promise<void>}
     */
    async updateCustomer (data) {
        try {
            const response = await http.put(`${PATH}/${data.id}`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customer_id: number, file: File}} data
     * @returns {Promise<any>}
     */
    async provisionCustomer (data) {
        try {
            const formData = new FormData()

            formData.append('customer_id', data.customer_id)
            formData.append('file', data.file)

            const response = await http.post(
                'sipcentric/provision',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{id: number}} data
     * @returns {Promise<void>}
     */
    async disableCustomer (data) {
        try {
            const response = await http.delete(`${PATH}/${data.id}`)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
